import { render, staticRenderFns } from "./bool-column.vue?vue&type=template&id=dd488d30&"
import script from "./bool-column.vue?vue&type=script&lang=ts&"
export * from "./bool-column.vue?vue&type=script&lang=ts&"
import style0 from "./bool-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports